var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.cfgs.tag ? this.cfgs.tag : 'h1',{tag:"component",class:_vm.cfgs.customClasses,style:(_vm.cfgs.style),domProps:{"innerHTML":_vm._s(_vm.values.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }